var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.414,
    height: 46.414,
    viewBox: "0 0 46.414 46.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M-415.567,159.519A23.21,23.21,0,0,1-392.361,182.8a23.217,23.217,0,0,1-23.256,23.135,23.214,23.214,0,0,1-23.158-23.378A23.221,23.221,0,0,1-415.567,159.519Zm-.052,18.879a6.212,6.212,0,0,0-.4-.506q-2.49-2.5-4.989-4.991a3.007,3.007,0,0,0-3.267-.836,3.08,3.08,0,0,0-1.158,5.167c1.685,1.71,3.393,3.4,5.09,5.1.122.122.238.252.376.4-.14.148-.256.277-.379.4q-2.529,2.53-5.057,5.059a2.994,2.994,0,0,0-.831,3.225,3.081,3.081,0,0,0,5.158,1.2c1.728-1.69,3.424-3.411,5.126-5.127A1.873,1.873,0,0,0-415.7,187c.263.247.359.332.449.422q2.564,2.563,5.128,5.125a3.02,3.02,0,0,0,3.221.856,3.087,3.087,0,0,0,1.206-5.186c-1.685-1.71-3.392-3.4-5.089-5.1-.122-.123-.238-.252-.376-.4.14-.148.257-.277.38-.4q2.511-2.513,5.025-5.023a3.18,3.18,0,0,0,1.015-2.125,3.108,3.108,0,0,0-1.806-3,3.04,3.04,0,0,0-3.475.625c-.96.931-1.895,1.887-2.84,2.833Z",
    transform: "translate(438.775 -159.519)",
    fill: "#d10a11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M-300.1,293.922l2.755-2.758c.945-.946,1.88-1.9,2.84-2.833a3.04,3.04,0,0,1,3.475-.626,3.108,3.108,0,0,1,1.806,3,3.18,3.18,0,0,1-1.015,2.125q-2.519,2.505-5.025,5.023c-.123.123-.24.252-.38.4.138.146.253.275.376.4,1.7,1.7,3.4,3.385,5.089,5.1a3.087,3.087,0,0,1-1.206,5.186,3.02,3.02,0,0,1-3.222-.856q-2.569-2.558-5.128-5.125c-.09-.09-.185-.174-.449-.422a1.877,1.877,0,0,1-.252.484c-1.7,1.716-3.4,3.438-5.126,5.127a3.081,3.081,0,0,1-5.158-1.2,2.993,2.993,0,0,1,.831-3.225q2.524-2.535,5.057-5.059c.123-.123.239-.252.379-.4-.138-.147-.254-.276-.376-.4-1.7-1.7-3.405-3.385-5.09-5.1a3.08,3.08,0,0,1,1.158-5.167,3.007,3.007,0,0,1,3.267.836q2.5,2.488,4.989,4.991A6.254,6.254,0,0,1-300.1,293.922Z",
    transform: "translate(323.258 -275.043)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelicon);
export default __webpack_public_path__ + "static/media/cancelicon.6ba9c1de203aa1444eaf4255c7d476bd.svg";
export { ForwardRef as ReactComponent };